import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';

const Layout = () => {
  const sidebarStyle = { width: '240px', background: '#2c3e50', color: '#fff', padding: '20px' };
  const contentStyle = { flex: 1, padding: '30px', background: '#ecf0f1' };

  const activeStyle = { background: '#3498db', color: '#fff' };
  const navLinkStyle = { color: '#ecf0f1', textDecoration: 'none', display: 'block', padding: '10px', marginBottom: '5px' };

  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      <div style={sidebarStyle}>
        <h2>SOW Generator</h2>
        <NavLink to="/" end style={({ isActive }) => ({ ...navLinkStyle, ...(isActive ? activeStyle : {}) })}>Dashboard</NavLink>
        <NavLink to="/projects" style={({ isActive }) => ({ ...navLinkStyle, ...(isActive ? activeStyle : {}) })}>Projects</NavLink>
        <NavLink to="/files" style={({ isActive }) => ({ ...navLinkStyle, ...(isActive ? activeStyle : {}) })}>Files</NavLink>
        <NavLink to="/generate" style={({ isActive }) => ({ ...navLinkStyle, ...(isActive ? activeStyle : {}) })}>Generate SOW</NavLink>
        <NavLink to="/cft-validation" style={({ isActive }) => ({ ...navLinkStyle, ...(isActive ? activeStyle : {}) })}>CFT Validation</NavLink>
        <NavLink to="/release-mgt" style={({ isActive }) => ({ ...navLinkStyle, ...(isActive ? activeStyle : {}) })}>Release Mgt</NavLink>
      </div>
      <main style={contentStyle}>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;